import { createAction } from 'redux-actions';
export const SET_LOADING = 'EXCHANGE/SET_LOADING';
export const setLoading = createAction(SET_LOADING);
export const STOP_LOADING = 'EXCHANGE/STOP_LOADING';
export const stopLoading = createAction(STOP_LOADING);
